var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "more_box flex_center flex_center_align btn_open" },
        [
          _c("svg-icon", {
            attrs: { "icon-class": "select" },
            on: { click: _vm.openDialog },
          }),
          _c("div"),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "mode",
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "custom-class": "layout-dialog",
            title: "商品明细管理",
            top: "5vh",
            width: "900px",
            "show-close": false,
            visible: _vm.dialogVisible,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "vab-query-form-mode",
            {
              staticClass: "dpform noborder",
              attrs: {
                model: _vm.queryForm,
                rules: _vm.rules,
                "enable-query-save": false,
                size: "mini",
                "label-position": "left",
                "label-width": "140px",
              },
              on: { search: _vm.onSearch },
            },
            [
              _c(
                "el-row",
                { staticClass: "flex_center_align", attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("vab-input", {
                        attrs: {
                          label: "商品",
                          "label-width": "100px",
                          prop: "itmcd",
                          maxlength: "4",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "padding-left": "0px" },
                      attrs: { span: 6 },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          "label-width": "100px",
                          prop: "itmcd",
                          maxlength: "4",
                          disabled: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "text_color" }, [
                      _vm._v("管理部門"),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "flex_center_align", attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("vab-input", {
                        attrs: {
                          label: "商品明细",
                          "label-width": "100px",
                          prop: "itmcd",
                          maxlength: "4",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("vab-radio-group", {
                        attrs: {
                          label: "支給品",
                          "label-width": "100px",
                          prop: "supplyGoodFlg",
                          "code-enum": _vm.$divisions.existFlagEnum,
                          filter: "existFlag",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "m20" },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("vab-table", {
                    ref: "table",
                    attrs: {
                      "api-url": "/api/mitmbasp/query",
                      columns: _vm.columns,
                      "custom-config": false,
                      height: "350",
                      "init-params": Object.assign({}, _vm.queryForm, {
                        sidx: "itmcd",
                        sort: "asc",
                      }),
                      "query-params": Object.assign({}, _vm.queryForm, {
                        sidx: "itmcd",
                        sort: "asc",
                      }),
                      "primary-key": "itmcd",
                      "primary-key-sort": "asc",
                      "enable-init": false,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "radioBox",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("vab-radio-group", {
                              attrs: {
                                label: "支給品",
                                "label-width": "100px",
                                prop: "supplyGoodFlg",
                                "code-enum": row.sectionCdList,
                                filter: "existFlag",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer flex_end",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                { staticClass: "flex_start flex_center_align" },
                [
                  _c(
                    "div",
                    { staticClass: "cancel", on: { click: _vm.close } },
                    [_vm._v("キャンセル")]
                  ),
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v("確定"),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }